import { render, staticRenderFns } from "./SearchOrder.vue?vue&type=template&id=3952264f"
import script from "./SearchOrder.vue?vue&type=script&lang=js"
export * from "./SearchOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports